import { render } from "./FabryView.vue?vue&type=template&id=2460e21d"
import script from "./FabryView.vue?vue&type=script&lang=js"
export * from "./FabryView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__